import React, { Fragment } from 'react'
import { Intro, AccordionGroup, Voiceover } from 'cvs-core'
import img1 from '../../assets/images/U1-T1-7a.svg'
import img2 from '../../assets/images/U1-T1-7b.svg'
import img3 from '../../assets/images/U1-T1-7c.svg'
import img4 from '../../assets/images/U1-T1-7d.svg'
import voAudio from '../../assets/vo/Learn-BensDilemma-01.mp3'

const vo = {
  sources: [
    {
      src: voAudio,
    },
  ],
  transcript:
    'Ben has a lot of friends, but lately there has been a lot of pressure in his friendships. Continue to learn more about the choices he can make regarding the use of e-cigarettes.',
}

const data = [
  {
    title: 'Meet Ben',
    content: (
      <Fragment>
        <img
          alt=""
          className="img-center"
          height="235"
          src={img1}
          width="568"
        />
        <p>
          Ben is a quiet kid who rarely gets into trouble and has a good group
          of friends. Lately, Ben has noticed that while most of his friends do
          not vape, a couple of them have been spending a lot more time in the
          school’s bathrooms. He goes in to see what’s up and learns that his
          friends have started vaping in the bathrooms between classes. They
          tell him where they are going to meet the next day and encourage him
          to participate.
        </p>
      </Fragment>
    ),
  },
  {
    title: 'Ben’s Choices',
    content: (
      <Fragment>
        <img
          alt=""
          className="img-center"
          height="235"
          src={img2}
          width="568"
        />
        <p>
          Ben’s head is spinning; he has so many choices. He can just say ‘no,’
          walk away, or stay out of the bathroom. He can start vaping with his
          friends. He can also reach out to a trusted adult for advice.
        </p>
      </Fragment>
    ),
  },
  {
    title: 'Ben’s Dilemma',
    content: (
      <Fragment>
        <img
          alt=""
          className="img-center"
          height="235"
          src={img3}
          width="568"
        />
        <p>
          Ben knows that it might be hard to say ‘no’ to his friends; he’s
          worried that they might make fun of him or stop hanging out with him.
          He doesn’t know much about vaping, but he feels like it is dangerous
          and something he shouldn’t do. He’s also afraid that his friends will
          turn on him if he chooses to share his concerns with an adult.
        </p>
      </Fragment>
    ),
  },
  {
    title: 'Let’s Investigate!',
    content: (
      <Fragment>
        <img
          alt=""
          className="img-center"
          height="235"
          src={img4}
          width="568"
        />
        <p>
          Let’s do some research with Ben to investigate some of the effects
          vaping/e-cigarettes have on our brains and bodies. We'll investigate
          some of the social consequences associated with vaping, so we can help
          Ben stand-up to the pressure.
        </p>
      </Fragment>
    ),
  },
]

export default {
  title: 'Ben’s Dilemma',
  path: '/learn/bens-dilemma',
  content: (
    <Fragment>
      <Voiceover {...vo} />
      <Intro
        title="Ben’s Dilemma"
        direction="Click to expand each section."
        lead="Click each tab below to learn more about the choices Ben can make regarding the use of e-cigarettes."
      />
      <AccordionGroup data={data} />
    </Fragment>
  ),
}



// WEBPACK FOOTER //
// ./src/data/Learn/BensDilemma.js